module.exports = __webpack_public_path__ + "img/warning.6f1b656f.png";